import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function Accessibility() {
  return (
    <StaticPage title="Accessibility" subtitle="RentalX is committed to making our platform accessible to everyone.">
      <Section title="Our Commitment">
        <p>RentalX strives to meet the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. We believe that everyone — regardless of ability — should be able to use our platform to find safe and affordable student accommodation.</p>
      </Section>

      <Section title="Features We've Implemented">
        <ul className="list-disc list-inside space-y-2">
          <li>Semantic HTML structure with proper heading hierarchy</li>
          <li>Keyboard navigation support across all interactive elements</li>
          <li>Sufficient colour contrast ratios throughout the interface</li>
          <li>Alt text on all meaningful images</li>
          <li>ARIA labels on form inputs and buttons</li>
          <li>Focus indicators on interactive elements</li>
          <li>Responsive design for all screen sizes and orientations</li>
          <li>Text resizing support without loss of content or functionality</li>
        </ul>
      </Section>

      <Section title="Assistive Technology">
        <p>RentalX has been tested with the following assistive technologies:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>NVDA + Chrome (Windows)</li>
          <li>VoiceOver + Safari (macOS and iOS)</li>
          <li>TalkBack + Chrome (Android)</li>
        </ul>
      </Section>

      <Section title="Known Issues">
        <p>We are actively working on the following accessibility improvements:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Improving ARIA roles on some dropdown components</li>
          <li>Adding skip-to-content links on all pages</li>
          <li>Enhanced focus management in modal dialogs</li>
        </ul>
      </Section>

      <Section title="Feedback & Support">
        <p>If you encounter any accessibility barriers on RentalX, please let us know:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Email: <strong>accessibility@rentalx.com.au</strong></li>
          <li>Phone: <strong>+61 1800 RENTAL</strong></li>
          <li>We aim to respond to all accessibility feedback within 2 business days</li>
        </ul>
        <p className="text-sm text-gray-500 mt-4">Last updated: February 2026</p>
      </Section>
    </StaticPage>
  );
}
